import React, { useEffect, useState } from 'react';
import axios from 'axios';
import ResumeSubmission from './ResumeForm';
import { getApiUrl } from '../config/api';
import { Dialog, DialogContent } from '@/Components/ui/dialog';
import { Card, CardContent, CardHeader } from '@/Components/ui/card';
import { Button } from '@/Components/ui/button';
import { Heading, Text } from '@/Components/ui/typography';
import { Stack } from '@/Components/ui/layout';

const JobForm = ({ jobId,onClose }) => {
  const [isResumeFormVisible, setIsResumeFormVisible] = useState(false);
  const [isFadingOut, setIsFadingOut] = useState(false);

  const [jobTitle, setJobTitle] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [responsibilities, setResponsibilities] = useState([]);
  const [skillsRequired, setSkillsRequired] = useState([]);
  const [salary, setSalary] = useState('');
  const [otherInformation, setOtherInformation] = useState('');


  const handleContinueClick = () => {
    setIsFadingOut(true); 
    setTimeout(() => {
      setIsResumeFormVisible(true); 
    }, 300); 
  };

  useEffect(()=>{
    const fetchJobForm = async () => {
      try{
        const response = await axios.get(getApiUrl(`/jobs/${jobId}`),
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            }
          }
        );
        
        
        const job = response.data;
        // Debug log removed — was leaking job data to console.


        setJobTitle(job.jobTitle);
        const companyResponse=await axios.get(getApiUrl(`/hirewithus/company/${job.companyAccountId}`),)
        setCompanyName(companyResponse.data.companyName);
        setResponsibilities(job.responsibilities.split('\n'));
        setSkillsRequired(job.tags.split(','));
        setSalary(`${job.minSalary} - ${job.maxSalary} ${job.salaryType}`);
        setOtherInformation(job.otherInformation);
      } catch(error){
        console.error("Failed to fetch job form:", error);
      }
    }
    fetchJobForm();
  },[]);

  return (
    <Dialog open={true} onOpenChange={onClose}>
      <DialogContent className="bg-slate-200 rounded-xl p-8 w-[90%] max-w-[800px] max-h-[85vh] overflow-y-auto relative opacity-100 transition-opacity duration-300">
        {isResumeFormVisible ? (
          <ResumeSubmission jobId={jobId} onClose={onClose} />
        ) : (
          <div className={isFadingOut ? 'opacity-0' : 'opacity-100'}>
            <CardHeader className="mb-6 pb-4 border-b border-slate-800 p-0">
              <div>
                <Heading level="h1" size="2xl" className="font-semibold text-slate-900 mb-2">
                  {jobTitle}
                </Heading>
                <Heading level="h2" size="lg" className="text-slate-500">
                  {companyName}
                </Heading>
              </div>
            </CardHeader>
            <Stack spacing="lg" className="flex flex-col gap-6">
              <article className="py-4">
                <Heading level="h3" size="xl" className="font-medium text-slate-700 mb-3">
                  Responsibilities
                </Heading>
                {responsibilities.map((responsibility, index) => (
                  <Text key={index} size="lg" className="text-slate-600 leading-relaxed mb-2">
                    {responsibility}
                  </Text>
                ))}
              </article>
              <article className="py-4">
                <Heading level="h3" size="xl" className="font-medium text-slate-700 mb-3">
                  Skill(s) required
                </Heading>
                <ul className="list-none p-0 flex flex-col gap-2">
                  {skillsRequired.map((skill, index) => (
                    <li key={index} className="text-slate-600 text-lg leading-relaxed pl-4 relative before:content-['•'] before:absolute before:left-0 before:text-green-600">
                      {skill}
                    </li>
                  ))}
                </ul>
              </article>
              <article className="py-4">
                <Heading level="h3" size="xl" className="font-medium text-slate-700 mb-3">
                  Who can apply
                </Heading>
                <Text size="lg" className="text-slate-600 leading-relaxed mb-2">
                  Lorem ipsum dolor sit amet consectetur. Ultrices vitae purus malesuada massa nec donec amet risus.
                </Text>
              </article>
              <article className="py-4">
                <Heading level="h3" size="xl" className="font-medium text-slate-700 mb-3">
                  Salary
                </Heading>
                <Text size="lg" className="text-slate-600 leading-relaxed mb-2">
                  {salary}
                </Text>
              </article>
              <article className="py-4">
                <Heading level="h3" size="xl" className="font-medium text-slate-700 mb-3">
                  Other information
                </Heading>
                <Text size="lg" className="text-slate-600 leading-relaxed mb-2">
                  {otherInformation}
                </Text>
              </article>
            </Stack>
            <Button 
              className="w-full py-3.5 mt-6 bg-gradient-to-r from-green-600 via-green-400 to-green-600 border-none rounded-lg text-white text-base font-medium cursor-pointer transition-opacity hover:opacity-90"
              onClick={handleContinueClick}
            >
              Continue
            </Button>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default JobForm;
